import Company from "./Company";
import Customer from "./Customer";
import Message from "./Message";
import { User, UserCompanies } from "./User";
import Account from "./Account";
import firebase from "firebase/compat/app";
import { DocumentReference, Timestamp } from "@firebase/firestore-types";

export interface Chat {}

export interface BadgeItem {
  unreadCount: number;
  className: string;
  channel: string;
}

// export interface Collaboration {
//   client?: DocumentReference;
//   id: string;
//   idCollab?: string;
//   idRoom?: string;
//   fullName?: string;
//   profileName?: string;
//   profilePicture?: string;
//   image?: string;
//   status?: "queue" | "handled";
//   // unreadMessages: BadgeItem[];
//   lastMessages?: string;
//   createdAt?: Timestamp;
//   updatedAt?: Timestamp;
//   handleAt?: Timestamp;
//   lastInteractionAt: firebase.firestore.Timestamp;
//   lastInteractionChannel?: string;
//   lastInteractionType?: string;
//   lastInteractionMessage?: string;
//   customer?: DocumentReference;
//   customerModel?: Customer;
//   toUser?: Array<DocumentReference>;
//   // toUserData?: Array<any>;
//   toUserModel?: Array<any>;
//   joinedUsers?: Array<DocumentReference>;
//   userModel?: User;
//   LastMessageModel?: Message;
//   company?: DocumentReference;
//   userCompanies?: Array<UserCompanies>;
//   companyModel?: Company;
//   phoneNumber?: string;
//   isActive?: boolean;
//   lastUserInteractionAt?: Timestamp;
//   roomsModel?: Array<Room>;
//   collaborationId?: string;
//   collaborationModel?: any;
//   lastCustomerInteractionAt: Timestamp;
//   tokopediaBuyerId?: string;
//   parent_document?: any;
//   parent_id?: any;
//   userSearchKeys?: any;
// }

export interface Collaboration {
  id: string;
  account?: DocumentReference;
  client?: DocumentReference;
  fullName?: string;
  image?: string;
  lastMessages?: string;
  lastInteractionAt: Timestamp;
  lastUserInteractionAt?: Timestamp;
  lastInteractionChannel: string;
  lastInteractionType: string;
  lastInteractionMessage: string;
  lastInteractionDestination?: string;
  lastInteractionStatus?: string;
  customer?: DocumentReference;
  customerModel?: Customer;
  handledByUser?: DocumentReference;
  toUser?: Array<DocumentReference>;
  joinedUsers?: Array<DocumentReference>;
  company?: DocumentReference;
  phoneNumber?: string;
  profileName?: string;
  profilePicture?: string;
  status: "queue" | "handled";
  createdAt: Timestamp;
  updatedAt: Timestamp;
  ttl?: Timestamp;
  handleAt?: Timestamp;
  isActive: boolean;
  conversationId?: string;
  userSearchKeys?: {
    tokopedia?: string;
    lazada?: string;
    shopee?: string;
    tiktok?: string;
  };
  unreadCount?: number;
  roomsModel?: Room[];
}

export const CollabsStatus = {
  queue: "queue",
  expired: "expired",
  handled: "handled",
  ended: "ended",
};

// export interface Room {
//   id: string;
//   createdAt?: Timestamp;
//   updatedAt?: Timestamp;
//   status?: "queue" | "handled";
//   collaboration?: DocumentReference;
//   collaborationModel?: Collaboration;
//   account?: DocumentReference;
//   accountData: {
//     name: string;
//     searchKey: string;
//     type: "whatsapp" | "shopee" | "lazada" | "tokopedia" | "tiktok";
//   };
//   accountModel?: Account;
//   toUser?: Array<DocumentReference>;
//   toUserOnline?: Array<DocumentReference>;
//   toUserModel?: User[];
//   lastCustomerInteractionAt?: Timestamp;
//   lastCustomerInteractionAtString?: Array<string>;
//   parent_document?: any;
//   parent_id?: any;
//   profileName?: string;
//   profilePicture?: string;
//   phoneNumber?: string;
//   userSearchKey?: string;
//   channel?: string;
// }

export interface Room {
  id: string;
  account?: DocumentReference;
  accountData: {
    name: string;
    type: string;
    searchKey?: string;
  };
  channel?: "whatsapp" | "shopee" | "lazada" | "tokopedia" | "tiktok";
  client?: DocumentReference;
  toUser?: Array<DocumentReference>;
  toUserOnline?: Array<DocumentReference>;
  status: "queue" | "handled";
  createdAt: Timestamp;
  updatedAt: Timestamp;
  ttl?: Timestamp;
  lastCustomerInteractionAt: Timestamp;
  lastCustomerInteractionAtString?: Array<string>;
  lastCustomerInteractionDestination?: string;
  lastCustomerInteractionStatus?: string;
  conversationId?: string;
  userSearchKey?: string;
  profileName?: string;
  profilePicture?: string;
  phoneNumber?: string;
  handledByUser?: DocumentReference;
  unreadCount?: number;
  parent_document?: Collaboration;
  parent_id?: string;
}

export type QueuedRoom = Collaboration & Room;
